import { useMemo, createElement } from "react";
import { I as I18nContext } from "./useTranslation-cf39c293.js";
function I18nextProvider(_ref) {
  let {
    i18n,
    defaultNS,
    children
  } = _ref;
  const value = useMemo(() => ({
    i18n,
    defaultNS
  }), [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value
  }, children);
}
export {
  I18nextProvider as I
};
//# sourceMappingURL=I18nextProvider-16dc4551.js.map
